import { render, staticRenderFns } from "./splitBillDetail.vue?vue&type=template&id=324aa0ee&scoped=true&"
import script from "./splitBillDetail.vue?vue&type=script&lang=js&"
export * from "./splitBillDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324aa0ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324aa0ee')) {
      api.createRecord('324aa0ee', component.options)
    } else {
      api.reload('324aa0ee', component.options)
    }
    module.hot.accept("./splitBillDetail.vue?vue&type=template&id=324aa0ee&scoped=true&", function () {
      api.rerender('324aa0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/BillingNative/splitBillDetail.vue"
export default component.exports